export enum Mask {
  CODE = '9999',
  PHONE = '(999) 999-9999',
}
